import styled from 'styled-components';

export const DesktopSignupBanner = styled.div<{ $isDelivery?: boolean }>`
  display: none;

  ${Styles.desktopLarge} {
    display: ${p => (p.$isDelivery ? 'block' : 'flex')};
    flex-direction: column;
    justify-content: center;
    flex: 1 1 auto;

    background: ${p => p.theme.primaryBackground};
    text-align: center;
    padding: 4rem 1rem;
    max-width: 500px;
    overflow-y: scroll;
  }
`;
